var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-editable-table',{ref:"editableTable",attrs:{"loading":_vm.loading,"columns":_vm.columns,"dataSource":_vm.dataSource,"rowNumber":true,"maxHeight":340,"disabledRows":{ dbFieldName:'id'}}})}
var staticRenderFns = []

export { render, staticRenderFns }